// Nodi di uscita: un nodo chiude il flusso quando non ha archi uscenti e il suo
// tipo non richiede per forza un seguito. Stessa regola del backend
// (flowValidator.js, "exit-node reachability"): tenerle allineate.
import { MUST_CONTINUE_TYPES } from './flowConstants';

/** Chiavi che l'editor appende ai `data` dei nodi e che non vanno persistite. */
export const INTERNAL_NODE_DATA_KEYS = ['__validationError', '__isExitNode'];

export const canBeExitNode = (type) => !MUST_CONTINUE_TYPES.has(type);

export function computeExitNodeIds(nodes = [], edges = []) {
  const sourceSet = new Set(edges.map(e => e.source));
  return new Set(
    nodes
      .filter(n => canBeExitNode(n.type) && !sourceSet.has(n.id))
      .map(n => n.id)
  );
}

/** Copia di `data` senza le chiavi interne dell'editor (vedi INTERNAL_NODE_DATA_KEYS). */
export function stripInternalKeys(data) {
  const copy = { ...(data || {}) };
  for (const key of INTERNAL_NODE_DATA_KEYS) delete copy[key];
  return copy;
}

/**
 * Ripulisce i nodi dallo stato interno dell'editor: e' cio' che si salva e cio'
 * che si confronta per capire se ci sono modifiche non salvate (badge di uscita
 * e marker di errore non sono modifiche dell'utente).
 */
export function stripInternalNodeData(nodes = []) {
  return nodes.map(n => ({ ...n, selected: undefined, data: stripInternalKeys(n.data) }));
}
